export enum IntegrationId {
  "Fábrica" = 1,
  "Marca" = 2,
  "Modelo" = 3,
  "Coleção" = 4, // Estação
  "Construção" = 5, // Linha
  // "Calce" = 6 // resumo
}

export enum IntegrationIdTranslation {
  "factory" = 1,
  "brand" = 2,
  "model" = 3,
  "collection" = 4, // Estação
  "construction" = 5, // Linha
  // "Calce" = 6 // resumo
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/integration-id.ts